import { UpdateFormValues } from '@/domain/termine/shared/types/UpdateTermineInput';
import dayjs from 'dayjs';

type DateMapperResult = {
  dateOnly: string;
  beginnDateTime: string;
  endeDateTime: string;
  wiederholungBisTime: string;
};

export function dateMapper(data: UpdateFormValues): DateMapperResult {
  const dateOnly = dayjs(data.datum).format('YYYY-MM-DD');
  const beginnDateTime = data.beginn
    ? dayjs(`${dateOnly}T${data.beginn}`).format('YYYY-MM-DDTHH:mm:ss')
    : '';
  const endeDateTime = data.ende
    ? dayjs(`${dateOnly}T${data.ende}`).format('YYYY-MM-DDTHH:mm:ss')
    : '';
  const wiederholungBisTime = data.wiederholungBis
    ? dayjs(data.wiederholungBis).format('YYYY-MM-DD')
    : '';
  return { beginnDateTime, endeDateTime, dateOnly, wiederholungBisTime };
}
